/// <amd-module name="Test/TestResultsFilter/Actions/FilterActionHub" />
import { FieldDetailsForTestResults } from "Test/common-util/Contracts/Test";
import { Action } from "VSS/Reflux/Action";

export class FilterActionHub {
	public initializeFilterValues = new Action<FieldDetailsForTestResults[]>();

	public initializeFilterValueItemData = new Action<FieldDetailsForTestResults[]>();
	public updateFilterValues = new Action<FieldDetailsForTestResults[]>();
	public clearFilterValues = new Action<void>();

	public onError = new Action<string>();
}
